import React from 'react';

interface LocationProps {
  venue: any;
}

const Location: React.FC<LocationProps> = ({ venue }) => {
  if (!venue) {
    return null;
  }

  const getGoogleMapsEmbedUrl = () => {
    // Use the exact same logic as Django template: venue.landmark.google_map_url
    if (venue.landmark?.google_map_url) {
      return venue.landmark.google_map_url;
    }
    
    return null;
  };

  const mapUrl = getGoogleMapsEmbedUrl();

  return (
    <div className="location-section">
      {mapUrl ? (
        <div className="map-container">
          <iframe 
            src={mapUrl}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      ) : (
        <div className="location-fallback">
          <i className="fas fa-map-pin"></i>
          <h5>Event Location</h5>
          <p>{venue.name}</p>
        </div>
      )}
    </div>
  );
};

export default Location;
